// extracted by mini-css-extract-plugin
export default {"wrapper":"ExportOrders_wrapper__ivY++","field":"ExportOrders_field__-mBCP"};